var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionLost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_19",
    "data-name": "Layer 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,1A31,31,0,1,0,63,32,31,31,0,0,0,32,1Zm0,60A29,29,0,1,1,61,32,29,29,0,0,1,32,61Z",
    fill: "#4080FF",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,7a24.82,24.82,0,0,0-14.88,4.91,1,1,0,0,0-.4.73,1,1,0,0,0,.29.78L50.58,47a1,1,0,0,0,.71.3h.07a1,1,0,0,0,.73-.4A25,25,0,0,0,32,7Zm8.65,27.23L34.41,28H41v2.93A15.87,15.87,0,0,1,40.65,34.23ZM39,22H37V15a1,1,0,0,1,2,0Zm2,2v2H32.41l-2-2ZM27,20.59l-2-2V15a1,1,0,0,1,2,0ZM51.15,44.74,42.3,35.88a18,18,0,0,0,.7-5V23a1,1,0,0,0-1-1H41V15a3,3,0,0,0-6,0v7H29V15a3,3,0,0,0-6,0v1.59l-3.74-3.74A23,23,0,0,1,51.15,44.74Z",
    fill: "#4080FF",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.42,17a1,1,0,0,0-.78-.29,1,1,0,0,0-.73.4,25,25,0,0,0,35,35,1,1,0,0,0,.4-.73,1,1,0,0,0-.29-.78ZM28,49V44h8v5ZM23,29.41,35.59,42H27.42A16,16,0,0,1,23,30.93ZM9,32a22.83,22.83,0,0,1,3.85-12.74L21,27.41v3.52a17.91,17.91,0,0,0,5,12.45V50a1,1,0,0,0,1,1h1v3.64A23,23,0,0,1,9,32ZM30,54.91V51h4v3.91c-.66.05-1.33.09-2,.09S30.66,55,30,54.91Zm6-.27V51h1a1,1,0,0,0,1-1V44.41l6.74,6.74A22.58,22.58,0,0,1,36,54.64Z",
    fill: "#4080FF",
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionLost);
export default __webpack_public_path__ + "static/media/connection-lost.4b4a82185d514c269cd98b55623f553f.svg";
export { ForwardRef as ReactComponent };